import BaseAPI from "./BaseAPI";

class InvoiceAPI extends BaseAPI {

    getAll = async () => {
        var promise = null;
            promise = await this.init().get("/account/invoice/get");
        return promise;
    };
	
    newInvoiceInit = async () => {
        var promise = null;
            promise = await this.init().get("/account/invoice/init");
        return promise;
    };

    createNewInvoice = async (data) => {
        var promise = null;
            promise = await this.init().post("/account/invoice/create", data);
        return promise;
    };

    recreateInvoice = async (key, data) => {
        var promise = null;
            promise = await this.init().post("/account/invoice/recreate/"+key, data);
        return promise;
    };


    getCustomerTimeRegistrations = async(data) => {
            var promise = null;
                promise = await this.init().post("/account/invoice/customer/"+data.customerKey.trim()+"/timeregistrations", data.data);
            return promise;
    }

	
}

export default new InvoiceAPI();